module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"from":"Начало","to":"Окончание"},"en":{"from":"From","to":"To"}}')
  delete Component.options._Ctor
}
